// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let NumberUtils = require("../../common/NumberUtils.bs.js");

function longitudeToWorldX(longitude) {
  return (longitude + 180) / 360;
}

function latitudeToWorldY(latitude) {
  let latitude$1 = NumberUtils.clampFloat(- 85.05112878, 85.05112878, latitude);
  let radians = latitude$1 * Math.PI / 180;
  return (1 - Math.log(Math.tan(radians) + 1 / Math.cos(radians)) / Math.PI) / 2;
}

function worldXToLongitude(worldX) {
  return worldX * 360 - 180;
}

function wrapWorldX(worldX) {
  return worldX - Math.floor(worldX);
}

function longitudeBoundsFromWorld(west, east) {
  if (east - west >= 1) {
    return {
      west: -180,
      east: 180
    };
  } else {
    return {
      west: worldXToLongitude(west - Math.floor(west)),
      east: worldXToLongitude(east - Math.floor(east))
    };
  }
}

function worldYToLatitude(worldY) {
  return Math.atan(Math.exp(Math.PI * (1 - 2 * worldY))) * 360 / Math.PI - 90;
}

function makeRequestViewport(bounds, zoomLevel) {
  let validLongitude = longitude => {
    let worldX = longitudeToWorldX(longitude);
    if (worldX >= 0) {
      return worldX <= 1;
    } else {
      return false;
    }
  };
  if (bounds.north > bounds.south && bounds.south >= - 85.05112878 && bounds.north <= 85.05112878 && validLongitude(bounds.east) && validLongitude(bounds.west) && bounds.east !== bounds.west && zoomLevel >= 0 && zoomLevel <= 22) {
    return {
      bounds: bounds,
      zoomLevel: zoomLevel
    };
  }
}

function center(bounds) {
  let west = longitudeToWorldX(bounds.west);
  let east = longitudeToWorldX(bounds.east);
  let east$1 = east < west ? east + 1 : east;
  let worldX = (west + east$1) / 2;
  return {
    lat: worldYToLatitude((latitudeToWorldY(bounds.north) + latitudeToWorldY(bounds.south)) / 2),
    lng: worldXToLongitude(worldX - Math.floor(worldX))
  };
}

function coverageBounds(viewport, zoomLevel) {
  let tileCount = 2 ** zoomLevel;
  let west = longitudeToWorldX(viewport.west);
  let east = longitudeToWorldX(viewport.east);
  let east$1 = east < west ? east + 1 : east;
  let north = latitudeToWorldY(viewport.north);
  let south = latitudeToWorldY(viewport.south);
  let width = east$1 - west;
  let height = south - north;
  let expandedWest = west - width;
  let expandedEast = east$1 + width;
  let expandedNorth = NumberUtils.clampFloat(0, 1, north - height);
  let expandedSouth = NumberUtils.clampFloat(0, 1, south + height);
  let longitudeBounds = longitudeBoundsFromWorld(Math.floor(expandedWest * tileCount) / tileCount, Math.ceil(expandedEast * tileCount) / tileCount);
  return {
    north: worldYToLatitude(Math.floor(expandedNorth * tileCount) / tileCount),
    east: longitudeBounds.east,
    south: worldYToLatitude(Math.ceil(expandedSouth * tileCount) / tileCount),
    west: longitudeBounds.west
  };
}

function bufferedBounds(viewport, factor) {
  let west = longitudeToWorldX(viewport.west);
  let east = longitudeToWorldX(viewport.east);
  let east$1 = east < west ? east + 1 : east;
  let north = latitudeToWorldY(viewport.north);
  let south = latitudeToWorldY(viewport.south);
  let horizontalPadding = (east$1 - west) * factor;
  let verticalPadding = (south - north) * factor;
  let longitudeBounds = longitudeBoundsFromWorld(west - horizontalPadding, east$1 + horizontalPadding);
  return {
    north: worldYToLatitude(NumberUtils.clampFloat(0, 1, north - verticalPadding)),
    east: longitudeBounds.east,
    south: worldYToLatitude(NumberUtils.clampFloat(0, 1, south + verticalPadding)),
    west: longitudeBounds.west
  };
}

function containsLongitudeBounds(outer, inner) {
  if (outer.west === -180 && outer.east === 180) {
    return true;
  }
  let outerWest = longitudeToWorldX(outer.west);
  let outerEast = longitudeToWorldX(outer.east);
  let outerEast$1 = outer.east < outer.west ? outerEast + 1 : outerEast;
  let innerWest = longitudeToWorldX(inner.west);
  let innerEast = longitudeToWorldX(inner.east);
  let innerEast$1 = inner.east < inner.west ? innerEast + 1 : innerEast;
  let match = innerWest < outerWest ? [
      innerWest + 1,
      innerEast$1 + 1
    ] : [
      innerWest,
      innerEast$1
    ];
  if (match[0] >= outerWest) {
    return match[1] <= outerEast$1;
  } else {
    return false;
  }
}

function contains(outer, inner) {
  if (inner.north <= outer.north && inner.south >= outer.south) {
    return containsLongitudeBounds(outer, inner);
  } else {
    return false;
  }
}

function shouldPrefetch(current, visibleBounds, zoomLevel) {
  if (zoomLevel !== current.zoomLevel) {
    return true;
  } else {
    return !contains(current.bounds, bufferedBounds(visibleBounds, 0.5));
  }
}

function nextRequestViewport(current, visibleBounds, zoomLevel) {
  if (zoomLevel === current.zoomLevel && contains(current.bounds, visibleBounds)) {
    return current;
  } else {
    return {
      bounds: coverageBounds(visibleBounds, zoomLevel),
      zoomLevel: zoomLevel
    };
  }
}

let maximumMercatorLatitude = 85.05112878;

let maximumZoomLevel = 22;

exports.maximumMercatorLatitude = maximumMercatorLatitude;
exports.maximumZoomLevel = maximumZoomLevel;
exports.longitudeToWorldX = longitudeToWorldX;
exports.latitudeToWorldY = latitudeToWorldY;
exports.worldXToLongitude = worldXToLongitude;
exports.wrapWorldX = wrapWorldX;
exports.longitudeBoundsFromWorld = longitudeBoundsFromWorld;
exports.worldYToLatitude = worldYToLatitude;
exports.makeRequestViewport = makeRequestViewport;
exports.center = center;
exports.coverageBounds = coverageBounds;
exports.bufferedBounds = bufferedBounds;
exports.containsLongitudeBounds = containsLongitudeBounds;
exports.contains = contains;
exports.shouldPrefetch = shouldPrefetch;
exports.nextRequestViewport = nextRequestViewport;
/* No side effect */
